var _Logo, _LeftMenu, _RightSectionWrapper, _SubmenuBackdrop;
import { clsx } from "clsx";
import CrossLogo from "@crehana/compass.layouts/CrossPlatformLogo";
import { useIsClient } from "@crehana/react-hooks";
import LeftMenu from "./components/LeftMenu";
import Logo from "./components/Logo";
import RightSectionWrapper from "./components/RightSectionWrapper";
import { useMainMenuContext } from "./hooks";
import Navbar from "./ui/Navbar";
import NavbarContainer from "./ui/NavbarContainer";
import SubmenuBackdrop from "./ui/SubmenuBackdrop";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var MainMenu = function MainMenu() {
  var isClient = useIsClient();
  var _useMainMenuContext = useMainMenuContext(),
    layoutConfig = _useMainMenuContext.layoutConfig,
    hasIntegration = _useMainMenuContext.hasIntegration,
    organizationSlug = _useMainMenuContext.organizationSlug,
    renderCustomLogo = _useMainMenuContext.renderCustomLogo;
  var renderLogo = function renderLogo() {
    if (renderCustomLogo) {
      return renderCustomLogo();
    }
    if (hasIntegration) {
      return /*#__PURE__*/_jsx(CrossLogo, {
        organizationSlug: organizationSlug || ''
      });
    }
    return _Logo || (_Logo = /*#__PURE__*/_jsx(Logo, {}));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Navbar, {
      children: /*#__PURE__*/_jsxs(NavbarContainer, {
        className: clsx('flex justify-between', layoutConfig.navType === 'dashboard' && 'max-w-full'),
        navType: layoutConfig.navType,
        children: [/*#__PURE__*/_jsxs("div", {
          className: clsx('flex items-center sm:flex-row-reverse', layoutConfig.newSidebarEnabled && 'w-1/2'),
          children: [isClient && (_LeftMenu || (_LeftMenu = /*#__PURE__*/_jsx(LeftMenu, {}))), renderLogo()]
        }), _RightSectionWrapper || (_RightSectionWrapper = /*#__PURE__*/_jsx(RightSectionWrapper, {}))]
      })
    }), _SubmenuBackdrop || (_SubmenuBackdrop = /*#__PURE__*/_jsx(SubmenuBackdrop, {}))]
  });
};
export default MainMenu;